<template>
	<div>
		<Breadcrumbs main="Work Management" title="Create Work" />
			<div class="container-fluid">
				<div class="row">
					<div class="col-sm-12">
						<div class="card">
							<div class="card-body">
	
								<div class="row mb-3">
									<div class="col-12">
										<a href="#" @click.prevent="handleGoBack" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</a>
									</div>
								</div>
	
								<form  @submit.prevent="addWork" enctype="multipart/form-data">
									<div class="form theme-form">

										<div class="row">
											<div class="col-md-12 mb-4">
												<div class="form-check mt-4">
													<input class="form-check-input" type="checkbox" id="is_enquiry" v-model="is_enquiry"/>
													<label class="form-check-label fw-bold" for="is_enquiry">
														This job is an enquiry
													</label>
												</div>
												<span class="validate-error" v-if="errors.is_enquiry">
													{{ errors.is_enquiry[0] }}
												</span>
											</div>
										</div>
										<div class="row">
											<div class="col-md-3">
												<div class="mb-3">
													<label class="control-label">Product<span class="text-danger">*</span></label>
													<select class="form-select" v-model="product_id" v-bind:class="{ 'is-invalid': Boolean(errors.product_id) }">
														<option value="">Select</option>
														<option v-for="product in products" :value="product.id">{{ product.product_name }}</option>
													</select>
													<span class="validate-error" v-if="errors.product_id">
														{{ errors.product_id[0] }}
													</span>
												</div>
											</div>

											<div class="col-md-3 form-group" v-if="product_id">
												<label class="control-label">Work Type<span class="text-danger">*</span></label>
													<select class="form-select" v-model="work_type" v-bind:class="{ 'is-invalid': Boolean(errors.work_type) }">
														<option value="">Select</option>
														<option value="1">New</option>
														<option value="2">Repair</option>
														<option value="3">Replacement</option>
													</select>
												<span class="validate-error" v-if="errors.work_type">
													{{ errors.work_type[0] }}
												</span>
											</div>

											<div class="col-md-3" v-if="(product_id == 1) && (work_type == 2 || work_type == 3)">
												<div>
													<label class="control-label">Select IMEI<span class="text-danger">*</span></label>
													<input class="form-control" type="text" placeholder="Search IMEI or Vehicle No" v-model="device_imei" @input="handleImeiInput" @focus="showSuggestions = true" @blur="handleInputBlur" v-bind:class="{ 'is-invalid': Boolean(errors.device_id) }"/>
													<ul
														v-if="showSuggestions && devices.length" class="list-group position-absolute"
														style="width:93%; z-index: 9999; max-height: 200px; overflow-y: auto;"
														@scroll="handleScroll" ref="suggestionList"
													>
														<li v-for="device in devices" :key="device.imei" class="list-group-item list-group-item-action" @mousedown.prevent="setImei(device)">
															{{ device.vehicle_no + ' - ' + device.imei }}
														</li>
													</ul>
													<span class="validate-error" v-if="errors.device_id">
														{{ errors.device_id[0] }}
													</span>
												</div>
											</div>

											<div class="col-md-3" v-if="(product_id != 1) && (work_type == 2 || work_type == 3)">
												<div>
													<label class="control-label">Search Vehicle No<span class="text-danger">*</span></label>
													<input class="form-control" type="text" placeholder="Search Vehicle No or Mobile" v-model="vehicle_search" @input="handleVehicleSearchInput" @focus="showSuggestions = true" @blur="handleInputBlur" v-bind:class="{ 'is-invalid': Boolean(errors.device_id) }"/>
													<ul
														v-if="showSuggestions && devices.length" class="list-group position-absolute"
														style="width:93%; z-index: 9999; max-height: 200px; overflow-y: auto;"
														@scroll="handleScroll" ref="suggestionList"
													>
														<li v-for="device in devices" :key="device.imei" class="list-group-item list-group-item-action" @mousedown.prevent="setImei(device)">
															{{ device.vehicle_no + ' - ' + device.mobile }}
														</li>
													</ul>
													<span class="validate-error" v-if="errors.device_id">
														{{ errors.device_id[0] }}
													</span>
												</div>
											</div>

											<div class="col-md-3" v-if="(product_id == 1) && (work_type == 1)">
												<div class="mb-3">
													<label class="control-label">RC Image<span class="text-danger">*</span></label>
													<input ref="fileinput" type="file" @change="setFile($event)" accept="image/*" class="form-control image-class" v-bind:class="{ 'is-invalid': Boolean(errors.rc_image) }"/>
													<span class="validate-error" v-if="errors.rc_image">
														{{ errors.rc_image[0] }}
													</span>
												</div>
											</div>

											<div class="col-md-3">
												<div class="mb-3">
													<label class="control-label">Select RTO<span class="text-danger">*</span></label>
													<input class="form-control" type="text" placeholder="Search RTO" v-model="rto_search" @input="handleRtoSearch" @focus="showRtoSuggestions = true" @blur="handleRtoInputBlur" v-bind:class="{ 'is-invalid': Boolean(errors.rto_id) }"/>
													<ul
														v-if="showRtoSuggestions && filteredRtoList.length" class="list-group position-absolute"
														style="width:93%; z-index: 9999; max-height: 200px; overflow-y: auto;"
														ref="rtoSuggestionList"
													>
														<li v-for="rto in filteredRtoList" :key="rto.id" class="list-group-item list-group-item-action" @mousedown.prevent="setRto(rto)">
															{{ rto.rto_code }} - {{ rto.rto_name }}
														</li>
													</ul>
													<span class="validate-error" v-if="errors.rto_id">
														{{ errors.rto_id[0] }}
													</span>
												</div>
											</div>
										</div>

										<div class="row">
											<div class="col-md-3">
												<div class="mb-3">
													<label class="control-label">Customer Name<span class="text-danger">*</span></label>
													<input class="form-control" type="text" placeholder="Enter Customer Name" v-model="customer_name" v-bind:class="{ 'is-invalid': Boolean(errors.customer_name) }"/>
													<span class="validate-error" v-if="errors.customer_name">
														{{ errors.customer_name[0] }}
													</span>
												</div>
											</div>

											<div class="col-md-3 form-group">
												<label class="control-label">Mobile No.<span class="text-danger">*</span></label>
												<input class="form-control" type="number" placeholder="Enter Customer Mobile" v-model="mobile" v-bind:class="{ 'is-invalid': Boolean(errors.mobile) }" maxlength="10" minlength="10" @input="restrictMobileInput"/>
												<span class="validate-error" v-if="errors.mobile">
													{{ errors.mobile[0] }}
												</span>
											</div>

											<div class="col-md-3 form-group">
												<label class="control-label">Vehicle Type.<span class="text-danger">*</span></label>
													<select class="form-select" v-model="vehicle_type" v-bind:class="{ 'is-invalid': Boolean(errors.vehicle_type) }">
														<option value="">Select Vehicle Type</option>
														<option v-for="type in vehicle_types" :value="type.id">{{ type.name }}</option>
													</select>
												<span class="validate-error" v-if="errors.vehicle_type">
													{{ errors.vehicle_type[0] }}
												</span>
											</div>

											<div class="col-md-3 form-group">
												<label class="control-label">Vehicle No.<span class="text-danger">*</span></label>
												<input class="form-control" type="text" placeholder="Enter Vehicle Number" v-model="vehicle_no" v-bind:class="{ 'is-invalid': Boolean(errors.vehicle_no) }"/>
												<span class="validate-error" v-if="errors.vehicle_no">
													{{ errors.vehicle_no[0] }}
												</span>
											</div>

											<div class="col-md-12">
												<div class="mb-3">
													<label class="control-label">Location<span class="text-danger">*</span></label>

													<GMapAutocomplete 
														@place_changed="setPlace" class="form-control" 
														placeholder="Search here to pick the required latitude and longitude..."
														:value="job.location"
														v-bind:class="{ 'is-invalid': Boolean(errors.location) }">
													</GMapAutocomplete>

													<GMapMap v-if="job.location"
														:center="center"
														:zoom="18"
														map-style-id="roadmap"
														:options="mapOptions"
														style="width: 100%; height: 30vmin"
														ref="mapRef"
														@click="handleMapClick">
															<GMapMarker 
																:position="marker.position"
																:clickable="true"
																:draggable="true"
																@drag="handleMarkerDrag"
																@click="panToMarker"
															/>
													</GMapMap > 

													<!-- <input class="form-control" type="text" placeholder="Search the location here..." v-model="location"/> -->
													<span class="validate-error" v-if="errors.location">
														{{ errors.location[0] }}
													</span>
												</div>
											</div>

											<div class="col-md-6">
												<div class="mb-3">
													<label class="control-label">Latitude<span class="text-danger">*</span></label>
													<input class="form-control" type="text" placeholder="" v-model="marker.position.lat" disabled v-bind:class="{ 'is-invalid': Boolean(errors.latitude) }"/>
													<span class="validate-error" v-if="errors.latitude">
														{{ errors.latitude[0] }}
													</span>
												</div>
											</div>
											<div class="col-md-6">
												<div class="mb-3">
													<label class="control-label">Longitude<span class="text-danger">*</span></label>
													<input class="form-control" type="text" placeholder="" v-model="marker.position.lng" disabled v-bind:class="{ 'is-invalid': Boolean(errors.longitude) }"/>
													<span class="validate-error" v-if="errors.longitude">
														{{ errors.longitude[0] }}
													</span>
												</div>
											</div>

											<div class="col-md-3">
												<div class="mb-3">
													<label class="control-label">Technician<span class="text-danger">*</span></label>
													<select class="form-select" v-model="technician_id" v-bind:class="{ 'is-invalid': Boolean(errors.technician_id) }">
														<option value="">Select Technician</option>
														<option v-for="technician in technicians" :value="technician.id">{{ technician.name }}</option>
													</select>
													<span class="validate-error" v-if="errors.technician_id">
														{{ errors.technician_id[0] }}
													</span>
												</div>
											</div>

											<div class="col-md-3">
												<div class="mb-3">
													<label class="control-label">Amount<span class="text-danger">*</span></label>
													<input class="form-control" type="number" placeholder="" v-model="amount" v-bind:class="{ 'is-invalid': Boolean(errors.amount) }"/>
													<span class="validate-error" v-if="errors.amount">
														{{ errors.amount[0] }}
													</span>
												</div>
											</div>

											<div class="col-md-3">
												<div class="mb-3">
													<label class="control-label">Date<span class="text-danger">*</span></label>
													<input class="form-control" type="date" placeholder="" v-model="date" v-bind:class="{ 'is-invalid': Boolean(errors.date) }"/>
													<span class="validate-error" v-if="errors.date">
														{{ errors.date[0] }}
													</span>
												</div>
											</div>

										</div>
										<div class="row mt-3">
											<div class="col-sm-12">
												<button class="btn btn-success me-2 float-end" type="submit" :disabled="isSubmitting">
													<span v-if="isSubmitting" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
													{{ isSubmitting ? 'Saving...' : 'Save' }}
												</button>
											</div>
										</div>
		
									</div>
								</form>
							</div>

							<div class="card-body" v-if="vehicle_no && vehicle_no.trim() !== '' || (device_imei && device_imei.trim() !== '') || (vehicle_search && vehicle_search.trim() !== '')">
								<div class="row">
									<div class="col-lg-12 col-md-12 mt-3">
										<div header-class="bg-transparent border-light" class="border border-light">
											<h4 class="font-size-16 bg-primary  border border-top-0 border-start-0 border-end-0 px-3 py-2 mb-3">
												Work Logs
											</h4>

											<div class="col-md-12 project-list filter-sort">
												<div class="row">
													<div class="col-md-8 d-flex mt-2">
														<label class="d-flex listing-length ms-1"><span>Show</span>
															<select class="form-select" v-model="listing_length" @change="fetchDeviceWorkLogs()">
																<option value="5">5</option>
																<option value="10">10</option>
																<option value="20">20</option>
															</select>
															<span>entries</span>
														</label>
													</div>
												</div>
											</div>

											<div class="table-responsive product-table">
												<table class="display" id="basic-1">
													<thead>
														<tr align="center">
															<th>Sl.No</th>
															<th>Customer</th>
															<th>Technician</th>
															<th>Location</th>
															<th>Date</th>
															<th>Product</th>
															<th>Type</th>
															<th>Amount</th>
															<th>Status</th>
															<th>Remarks</th>
														</tr>
													</thead>
													<tbody v-if="Boolean(device_work_logs.length)">
														<tr align="center" v-for="(work, index) in device_work_logs" :key="index">
															<td>{{ (from - 1) + index + 1 }}</td>
															<td>{{ work.customer_name }}</td>
															<td>{{ work.technician?.name || 'N/A' }}</td>
															<td>{{ work.location }}</td>
															<td>{{ proxy.$filters.convertDate(work.date) }}</td>
															<td>{{ work.product?.product_name }}</td>
															<td>
																<span v-if="work.service_type == 1">New</span>
																<span v-else-if="work.service_type == 2">Repair</span>
																<span v-else>Replacement</span>
															</td>
															<td>Rs. {{ work.total_amount }}</td>
															<td>
																<span class="badge rounded-pill bg-warning" v-if="work.job_status === 1">Pending</span>
																<span class="badge rounded-pill bg-primary" v-else-if="work.job_status === 2">Ongoing</span>
																<span class="badge rounded-pill bg-success" v-else-if="work.job_status === 3">Completed</span>
																<span class="badge rounded-pill bg-danger" v-else-if="work.job_status === 4">Requested</span>
																<span class="badge rounded-pill bg-danger" v-else-if="work.job_status === 5">Cancelled</span>
																<span class="badge rounded-pill bg-secondary" v-else-if="work.job_status === 6">Reassigned</span>
																<span class="badge rounded-pill bg-warning" v-else-if="work.job_status === 7">Pending</span>
															</td>
															<td>{{ work.remarks }}</td>
														</tr>
													</tbody>
													<tbody v-else>
														<tr>
															<td colspan="10" class="text-center">No work logs found</td>
														</tr>
													</tbody>
												</table>
											</div>

											<!----pagination starts --->
											<nav aria-label="Page navigation" class="mt-2">
												<ul class="pagination">
													<li class="page-item" v-for="(page, index) in pagination" :key="index" :class="[{ disabled: !page.url }, { active: page.active }]">
													<a class="page-link" href="#" @click.prevent="fetchDeviceWorkLogs(page.url)" tabindex="-1">
														<span v-if="index === 0">Prev</span>
														<span v-else-if="index === pagination.length - 1">Next</span>
														<span v-else v-html="page.label"></span>
													</a>
													</li>
												</ul>
											</nav>
											<!----pagination ends --->

										</div>
									</div>
								</div>
							</div>

						</div>
					</div>
				</div>
			 </div>
 
	</div>
 </template>

<script setup>
	import Swal from '@/utils/swal';
	import { get, post } from '@/utils/api';
	import { routes } from '@/constants/routes';
	import { onMounted, onUnmounted, ref, getCurrentInstance, computed } from 'vue';
	import { useRouter } from 'vue-router';
	import { debounce } from 'lodash';
	import { goBack } from '@/utils/urlHider';

	// Get today's date in local timezone (IST)
	const now = new Date();
	const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
	// Format date as YYYY-MM-DD for date input using local timezone
	const year = today.getFullYear();
	const month = String(today.getMonth() + 1).padStart(2, '0');
	const day = String(today.getDate()).padStart(2, '0');
	const todayFormatted = `${year}-${month}-${day}`;
	const date = ref(todayFormatted);

	const min = date.value;
	const max = todayFormatted;
	
 	const { proxy } = getCurrentInstance();
	const fetchDevicesDebounced = debounce(() => fetchDevices(), 300);
	const fetchAllDevicesDebounced = debounce(() => fetchAllDevicesForSearch(), 300);
	const router = useRouter();
	const products = ref([]);
	const product_id = ref("");
	const mobile = ref("");
	const customer_name = ref("");
	const work_type = ref("");
	const technician_id = ref("");
	const vehicle_no = ref("");
	const location = ref("");
	const latitude = ref("");
	const longitude = ref("");
	const technicians = ref({});
	const amount = ref("");
	const is_enquiry = ref(false);
	const isSubmitting = ref(false);
	const rc_image = ref(null);
	const device_imei = ref("");
	const vehicle_search = ref(""); // New variable for vehicle search field
	const devices = ref([]);
	const showSuggestions = ref(false);
	const device_id = ref("");
	const vehicle_types = ref([]);
	const vehicle_type = ref("");
	const errors = ref({});
	const page = ref(1);
	const limit = 20;
	const suggestionList = ref(null);
 	const device_work_logs = ref([]);
	const listing_length = ref(10);
	const from = ref(null);
	const to = ref(null);
	const total = ref(null);
	const pagination = ref({});
	const mapRef = ref(null);
	const devices_data = ref([]);
	// RTO dropdown variables
	const rto_list = ref([]);
	const rto_id = ref("");
	const rto_search = ref("");
	const showRtoSuggestions = ref(false);
	const rtoSuggestionList = ref(null);

	const marker = ref({
		position: { lat: null, lng: null }
	});

	const center = ref({
		lat: null,
		lng: null
	});

	const current_place = ref(null);

	const mapOptions = {
		disableDefaultUI: true,
	};

	const handleGoBack = () => {
		const success = goBack(router);
		if (!success) {
			// If no history, go to dashboard as fallback
			router.push({ name: 'defaultRoot' });
		}
	};

	const restrictMobileInput = (event) => {
		// Remove any non-digit characters and limit to 10 digits
		const value = event.target.value.replace(/\D/g, '').slice(0, 10);
		mobile.value = value;
	};

	const job = ref({
		location: '',
		latitude: null,
		longitude: null
	});

	const geolocate = () => {
		navigator.geolocation.getCurrentPosition((position) => {
			marker.value.position = {
			lat: position.coords.latitude,
			lng: position.coords.longitude,
			};
			panToMarker();
		});
	};

	const panToMarker = () => {
		mapRef.value?.panTo(marker.value.position);
	};

	const handleMarkerDrag = (e) => {
		marker.value.position = {
			lat: e.latLng.lat(),
			lng: e.latLng.lng(),
		};
		// Update job coordinates when marker is dragged
		job.value.latitude = e.latLng.lat();
		job.value.longitude = e.latLng.lng();
	};

	const handleMapClick = (e) => {
		marker.value.position = {
			lat: e.latLng.lat(),
			lng: e.latLng.lng(),
		};
		// Update job coordinates when map is clicked
		job.value.latitude = e.latLng.lat();
		job.value.longitude = e.latLng.lng();
		console.log(e);
	};

	const setPlace = (place) => {
		current_place.value = place;
		if (current_place.value) {
			const lat = current_place.value.geometry.location.lat();
			const lng = current_place.value.geometry.location.lng();
			const markerPos = { lat, lng };

			center.value = markerPos;
			marker.value.position = markerPos;

			job.value.location = place.formatted_address;
			job.value.latitude = lat;
			job.value.longitude = lng;
		}
	};


	const handleScroll = () => {
		// Note: Pagination removed as it's not supported by the current API
		// If pagination is needed, it can be added to fetchAllDevicesForSearch
	};

	// Computed property for filtered RTO list
	const filteredRtoList = computed(() => {
		if (!rto_search.value || rto_search.value.trim() === '') {
			return rto_list.value;
		}
		const searchTerm = rto_search.value.toLowerCase();
		return rto_list.value.filter(rto => 
			rto.rto_code.toLowerCase().includes(searchTerm) || 
			rto.rto_name.toLowerCase().includes(searchTerm)
		);
	});

	const fetchProducts = () => {

		get(routes.AllProducts, {}, false)
			.then((response) => {
				if (response.status === 200) {
					products.value = response.data.data;
					console.log(response.data.data);
				} else {
					Swal.fire('Error', response.data.message || 'Error fetching products', 'error');
				}
			})
			.catch((error) => {
				if (error.response?.status === 422) {
					Swal.fire('Validation Error', 'Please check your input data', 'error');
				} else if (error.response?.status === 500) {
					Swal.fire('Server Error', error.response.statusText || 'Server error occurred', 'error');
				} else if (error.response?.status === 401) {
					Swal.fire('Unauthorized', error.response.statusText || 'Please login again', 'error');
					router.push({ name: 'login' });
				} else {
					Swal.fire('Error', error.response.data?.message || 'An error occurred', 'error');
				}
			});
	};

	const fetchAllDevices = (searchTerm = '') => {

		const params = {
			keyword: searchTerm,
		};

		get(routes.AllDevices, { params }, false)
			.then((response) => {
				if (response.status === 200) {
					devices_data.value = response.data.data;
					console.log('All Devices Data:', response.data.data);
				} else {
					Swal.fire('Error', response.data.message || 'Error fetching devices', 'error');
				}
			})
			.catch((error) => {
				if (error.response?.status === 422) {
					Swal.fire('Validation Error', 'Please check your input data', 'error');
				} else if (error.response?.status === 500) {
					Swal.fire('Server Error', error.response.statusText || 'Server error occurred', 'error');
				} else if (error.response?.status === 401) {
					Swal.fire('Unauthorized', error.response.statusText || 'Please login again', 'error');
					router.push({ name: 'login' });
				} else {
					Swal.fire('Error', error.response.data?.message || 'An error occurred', 'error');
				}
			});
	};

	const fetchAllDevicesForSearch = () => {
		// Determine which search term to use based on product_id
		let searchTerm = '';
		if (product_id.value == 1 || product_id.value == '1') {
			searchTerm = device_imei.value;
		} else {
			searchTerm = vehicle_search.value;
		}

		// Don't fetch if no keyword is provided
		if (!searchTerm || searchTerm.trim() === '') {
			devices.value = [];
			showSuggestions.value = false;
			return;
		}

		const params = {
			keyword: searchTerm,
		};

		get(routes.AllDevices, { params }, false)
			.then((response) => {
				if (response.status === 200) {
					console.log('All Devices Search Results:', response.data.data);
					// Store all devices with imei and vehicle_no
					devices.value = response.data.data || [];
					// Show suggestions if we have devices and input is focused
					if (devices.value.length > 0) {
						showSuggestions.value = true;
					}
				} else {
					Swal.fire('Error', response.data.message || 'Error fetching devices', 'error');
				}
			})
			.catch((error) => {
				if (error.response?.status === 422) {
					Swal.fire('Validation Error', 'Please check your input data', 'error');
				} else if (error.response?.status === 500) {
					Swal.fire('Server Error', error.response.statusText || 'Server error occurred', 'error');
				} else if (error.response?.status === 401) {
					Swal.fire('Unauthorized', error.response.statusText || 'Please login again', 'error');
					router.push({ name: 'login' });
				} else {
					Swal.fire('Error', error.response.data?.message || 'An error occurred', 'error');
				}
			});
	};

	const fetchTechnicians = () => {

		get(routes.AllTechnicians, {}, false)
			.then((response) => {
				if (response.status === 200) {
					console.log(response.data.data);
					technicians.value = response.data.data;
				} else {
					Swal.fire('Error', response.data.message || 'Error fetching technicians', 'error');
				}
			})
			.catch((error) => {
				if (error.response?.status === 422) {
					Swal.fire('Validation Error', 'Please check your input data', 'error');
				} else if (error.response?.status === 500) {
					Swal.fire('Server Error', error.response.statusText || 'Server error occurred', 'error');
				} else if (error.response?.status === 401) {
					Swal.fire('Unauthorized', error.response.statusText || 'Please login again', 'error');
					router.push({ name: 'login' });
				} else {
					Swal.fire('Error', error.response.data?.message || 'An error occurred', 'error');
				}
			});
	};

	const fetchDevices = () => {
		// Determine which search term to use based on product_id
		let searchTerm = '';
		if (product_id.value == 1 || product_id.value == '1') {
			searchTerm = device_imei.value;
		} else {
			searchTerm = vehicle_search.value;
		}

		// Don't fetch if no keyword is provided
		if (!searchTerm || searchTerm.trim() === '') {
			devices.value = [];
			showSuggestions.value = false;
			return;
		}

		const params = {
			keyword: searchTerm,
		};

		get(routes.searchJobData, { params }, false)
			.then((response) => {
				if (response.status === 200) {
					console.log(response.data.data);
					// Filter out devices with null IMEI only for product_id = 1
					if (product_id.value == 1 || product_id.value == '1') {
						devices.value = (response.data.data || []).filter(device => device.imei !== null && device.imei !== '');
					} else {
						devices.value = response.data.data || [];
					}
					// Show suggestions if we have devices and input is focused
					if (devices.value.length > 0) {
						showSuggestions.value = true;
					}

				} else {
					Swal.fire('Error', response.data.message || 'Error fetching devices', 'error');
				}
			})
			.catch((error) => {
				if (error.response?.status === 422) {
					Swal.fire('Validation Error', 'Please check your input data', 'error');
				} else if (error.response?.status === 500) {
					Swal.fire('Server Error', error.response.statusText || 'Server error occurred', 'error');
				} else if (error.response?.status === 401) {
					Swal.fire('Unauthorized', error.response.statusText || 'Please login again', 'error');
					router.push({ name: 'login' });
				} else {
					Swal.fire('Error', error.response.data?.message || 'An error occurred', 'error');
				}
			});
	};

	const fetchVehicleTypes = () => {

		get(routes.VehicleTypes, {}, false)
			.then((response) => {
				if (response.status === 200) {
					console.log(response.data.data);
					vehicle_types.value = response.data.data;
				} else {
					Swal.fire('Error', response.data.message || 'Error fetching vehicle types', 'error');
				}
			})
			.catch((error) => {
				if (error.response?.status === 422) {
					Swal.fire('Validation Error', 'Please check your input data', 'error');
				} else if (error.response?.status === 500) {
					Swal.fire('Server Error', error.response.statusText || 'Server error occurred', 'error');
				} else if (error.response?.status === 401) {
					Swal.fire('Unauthorized', error.response.statusText || 'Please login again', 'error');
					router.push({ name: 'login' });
				} else {
					Swal.fire('Error', error.response.data?.message || 'An error occurred', 'error');
				}
			});
	};

	const fetchRTOList = () => {

		get(routes.RTOList, {}, false)
			.then((response) => {
				if (response.status === 200) {
					console.log(response.data.data);
					rto_list.value = response.data.data;
				}
			})
			.catch((error) => {
				if (error.response?.status === 422) {
					Swal.fire('Validation Error', 'Please check your input data', 'error');
				} else if (error.response?.status === 500) {
					Swal.fire('Server Error', error.response.statusText || 'Server error occurred', 'error');
				}
				else if (error.response?.status === 401) {
					Swal.fire('Unauthorized', error.response.statusText || 'Please login again', 'error');
					router.push({ name: 'login' });
				} else {
					Swal.fire('Error', error.response.data?.message || 'An error occurred', 'error');
				}
			});
	};

	const setFile = (e) => {
		rc_image.value = e.target.files[0];
	};

	const addWork = () => {
		
		errors.value = {};

		if ((product_id.value == 1 || product_id.value == '1') && (work_type.value == 1 || work_type.value == '1')) {
			if (!rc_image.value) {
				Swal.fire('Validation Error', 'RC Image is required for new work type', 'error');
				return;
			}
		}

		if (!rto_id.value) {
			Swal.fire('Validation Error', 'Please select an RTO', 'error');
			return;
		}

		// Set loading state
		isSubmitting.value = true;

		const formData = new FormData();
		formData.append('product_id', product_id.value);
		formData.append('work_type', work_type.value);
		formData.append('imei', device_imei.value || '');
		formData.append('customer_name', customer_name.value);
		formData.append('vehicle_no', vehicle_no.value);
		formData.append('vehicle_type', vehicle_type.value);
		formData.append('mobile', mobile.value);
		formData.append('date', date.value);
		// formData.append('location', location.value);
		// formData.append('latitude', latitude.value);
		// formData.append('longitude', longitude.value);
		formData.append('location', job.value.location);
		formData.append('latitude', job.value.latitude);
		formData.append('longitude', job.value.longitude);
		formData.append('is_enquiry', is_enquiry.value ? 1 : 2);
		if(rc_image.value){
			formData.append('rc_image', rc_image.value);
		}
		formData.append('technician_id', technician_id.value);
		formData.append('amount', amount.value);
		formData.append('rto_id', rto_id.value);

		post(routes.AddWork, formData, false)
			.then((response) => {
				if (response.status === 200) {
					Swal.fire('', response.data.message || 'Work added successfully', 'success');
					router.push({ name: 'job_management'});
				} else {
					isSubmitting.value = false;
					Swal.fire('', response.data.message || 'Failed to add work', 'error');
				}
			})
			.catch((error) => {
				isSubmitting.value = false;
				if (error.response?.status === 422) {
					errors.value = error.response.data.message;
					// Show first validation error in Swal
					const firstError = Object.values(error.response.data.message)[0];
					if (firstError && firstError[0]) {
						Swal.fire('Validation Error', firstError[0], 'error');
					}
				} else if (error.response?.status === 500) {
					Swal.fire('Server Error', error.response.statusText || 'Server error occurred', 'error');
				} else if (error.response?.status === 401) {
					Swal.fire('Unauthorized', error.response.statusText || 'Please login again', 'error');
					router.push({ name: 'login' });
				} else {
					Swal.fire('Error', error.response.data?.message || 'An error occurred', 'error');
				}
			});

	};

	const fetchDeviceWorkLogs = (url = null) => {
		// Don't fetch if no identifying information is provided
		if ((!device_imei.value || device_imei.value.trim() === '') && 
			(!vehicle_search.value || vehicle_search.value.trim() === '') && 
			(!vehicle_no.value || vehicle_no.value.trim() === '')) {
			device_work_logs.value = [];
			return;
		}

		let params = {
			limit: listing_length.value,
		};

		// For product_id = 1 (Select IMEI field), use vehicle_no (from new fetchAllDevices)
		if (product_id.value == 1 || product_id.value == '1') {
			params.device_imei = null;
			params.vehicle_no = vehicle_no.value || '';
			params.mobile = null;
		} else {
			// For product_id != 1 (Search Vehicle No field), use vehicle_no (from old fetchDevices)
			params.device_imei = null;
			params.vehicle_no = vehicle_no.value || '';
			params.mobile = null;
		}

		const requestUrl = url ?? routes.DeviceWorkLogs;

		get(requestUrl, { params }, false)
			.then((response) => {
				if (response.status === 200) {

					console.log('Device Work Logs:', response.data.data);
					device_work_logs.value = response.data.data.data || [];
					pagination.value = response.data.data.links || {};
					from.value = response.data.data.from;
					to.value = response.data.data.to;
					total.value = response.data.data.total;

				} else {
					Swal.fire('', response.data.message || 'Error fetching data', 'error');
				}
			})
			.catch((error) => {
				if (error.response?.status === 422) {
					Swal.fire('Validation Error', error.response.data.message.limit?.[0] || error.response.data.message.device_id?.[0] || 'Please check your input data', 'error');
				} else if (error.response?.status === 500) {
					Swal.fire('Server Error', error.response.statusText || 'Server error occurred', 'error');
				} else if (error.response?.status === 401) {
					Swal.fire('Unauthorized', error.response.statusText || 'Please login again', 'error');
					router.push({ name: 'login' });
				} else {
					Swal.fire('Error', error.response.data?.message || 'An error occurred', 'error');
				}
			});
	};

	const setImei = (device) => {
		// Use the device's vehicle_no to fill the vehicle_no field
		vehicle_no.value = device.vehicle_no || '';
		
		// For product_id != 1 (non-GPS), use data directly from old fetchDevices
		if (product_id.value != 1 && product_id.value != '1') {
			vehicle_search.value = device.vehicle_no || '';
			device_imei.value = ''; // Keep IMEI empty for non-product-1
			mobile.value = device.mobile || '';
			device_id.value = device.id;
			console.log('Non-GPS Device Data:', device);
		} else {
			// For product_id = 1 (GPS), use data directly from AllDevices API only
			device_imei.value = device.imei || '';
			vehicle_search.value = ''; // Keep vehicle_search empty for product-1
			mobile.value = device.mobile || '';
			device_id.value = device.id;
			console.log('GPS Device Data from AllDevices:', device);
		}
		
		showSuggestions.value = false;
		fetchDeviceWorkLogs();
	};

	// Clear IMEI field and reset related data
	const clearImeiField = () => {
		device_imei.value = '';
		vehicle_no.value = '';
		mobile.value = '';
		device_id.value = '';
		device_work_logs.value = [];
		showSuggestions.value = false;
		devices.value = [];
	};

	// Clear vehicle search field and reset related data
	const clearVehicleSearchField = () => {
		vehicle_search.value = '';
		vehicle_no.value = '';
		mobile.value = '';
		device_id.value = '';
		device_work_logs.value = [];
		showSuggestions.value = false;
		devices.value = [];
	};

	// Watch for changes in device_imei to handle clearing
	const watchDeviceImei = () => {
		if (!device_imei.value || device_imei.value.trim() === '') {
			clearImeiField();
		}
	};

	// Watch for changes in vehicle_search to handle clearing
	const watchVehicleSearch = () => {
		if (!vehicle_search.value || vehicle_search.value.trim() === '') {
			clearVehicleSearchField();
		}
	};

	// Handle IMEI input with debounced search and clear functionality
	const handleImeiInput = () => {
		watchDeviceImei();
		if (device_imei.value && device_imei.value.trim() !== '') {
			// Use fetchAllDevices for the search
			fetchAllDevicesDebounced();
		}
	};

	// Handle vehicle search input with debounced search and clear functionality
	const handleVehicleSearchInput = () => {
		watchVehicleSearch();
		if (vehicle_search.value && vehicle_search.value.trim() !== '') {
			// Use the old fetchDevices for non-GPS products
			fetchDevicesDebounced();
		}
	};

	// Handle input blur with delay to allow for selection
	const handleInputBlur = () => {
		setTimeout(() => {
			showSuggestions.value = false;
		}, 200);
	};

	// Add click outside functionality
	const handleClickOutside = (event) => {
		const inputElement = event.target.closest('.form-control');
		const suggestionElement = event.target.closest('.list-group');
		
		if (!inputElement && !suggestionElement) {
			showSuggestions.value = false;
			showRtoSuggestions.value = false;
		}
	};

	onMounted(() => {
		fetchProducts();
		fetchTechnicians();
		fetchVehicleTypes();
		fetchRTOList();

		// Add click outside listener
		document.addEventListener('click', handleClickOutside);
	});

	onUnmounted(() => {
		// Remove click outside listener
		document.removeEventListener('click', handleClickOutside);
	});

	// RTO dropdown handlers
	const handleRtoSearch = () => {
		if (rto_search.value && rto_search.value.trim() !== '') {
			showRtoSuggestions.value = true;
		} else {
			showRtoSuggestions.value = false;
			// Clear RTO ID if search is cleared
			if (!rto_search.value || rto_search.value.trim() === '') {
				rto_id.value = '';
			}
		}
	};

	const handleRtoInputBlur = () => {
		setTimeout(() => {
			showRtoSuggestions.value = false;
		}, 200);
	};

	const setRto = (rto) => {
		rto_search.value = `${rto.rto_code} - ${rto.rto_name}`;
		rto_id.value = rto.id;
		showRtoSuggestions.value = false;
	};

	// Clear RTO field
	const clearRtoField = () => {
		rto_search.value = '';
		rto_id.value = '';
		showRtoSuggestions.value = false;
	};


</script>